import { memo } from 'react';

import { IKnmPreview } from 'APIPackage/KnmSearchModule/interfaces/IKnmPreview';

import styles from './KnmPreview.module.scss';
import { KnmSubtitle } from './KnmSubtitle';

interface IKnmProsecutorProps {
  passportData: IKnmPreview;
}

export const KnmProsecutor = memo(({ passportData }: IKnmProsecutorProps) => (
  <div className={styles.ColumnContent}>
    <KnmSubtitle title="Орган прокуратуры">
      {passportData.prosecName && (
        <div className={styles.Row}>
          <div className={styles.ColText}>Наименование прокуратуры</div>
          <div className={styles.ColValue}>{passportData.prosecName}</div>
        </div>
      )}
    </KnmSubtitle>
  </div>
));
